<template>
    <div>

        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane active" id="activity">

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-t">Contact Information</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Type</th>
                                            <th>Contact</th>
                                            <th>Email</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in contacts">
                                            <td>{{item._Type}}</td>
                                            <td>{{item.ContactNo}}</td>
                                            <td>{{item.Email}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showContactModal(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteContact" v-on:click="contactIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="4">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showContactModal()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Address</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Type</th>
                                            <th>City</th>
                                            <th>Address</th>
                                            <th>Zip Code</th>
                                            <th align="center">Is Postal</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in addresses">
                                            <td>{{item._Type}}</td>
                                            <td>{{item._City}}</td>
                                            <td>{{item.Address}}</td>
                                            <td>{{item.ZipCode}}</td>
                                            <td align="center"><input type="checkbox" disabled v-model="item.IsPostalAddress" /></td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showAddressModal(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteAddress" v-on:click="addressIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="6">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showAddressModal()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Emergency Contact</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Relation</th>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>Contact No</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in emergencyContacts">
                                            <td>{{item._Relation}}</td>
                                            <td>{{item._Type}}</td>
                                            <td>{{item.Name}}</td>
                                            <td>{{item.ContactNo}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showEmergencyContactModal(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteEmergencyContact" v-on:click="emergencyContactIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="5">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showEmergencyContactModal()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="card-footer">
            <a class="btn btn-primary" href="../Employees/List">Back to List</a>
            <div class="float-right">
                <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
            </div>
        </div>

        <div class="modal fade" id="modalContact">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Contact</h4>
                    </div>

                    <form id="contact" v-on:submit="saveContact">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Type *</label>
                                        <select class="form-control" v-model="contact.Type" required>
                                            <option value="">--Select--</option>
                                            <option value="0">Personal</option>
                                            <option value="1">Home</option>
                                            <option value="2">Work</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Contact *</label>
                                        <input class="form-control" type="tel" v-mask="'###########'" pattern=".{11,11}" title="11 digits required" v-model="contact.ContactNo" required />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="email" v-model="contact.Email" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success">Save changes</button>
                        </div>
                    </form>

                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalDeleteContact">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Delete</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h3>Are you sure you want to delete this record ?</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="deleteContact()" class="btn btn-danger">Delete</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalAddress">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Address</h4>
                    </div>

                    <form id="address" v-on:submit="saveAddress">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Type *</label>
                                        <select class="form-control" v-model="address.Type" required>
                                            <option value="">--Select--</option>
                                            <option value="0">Permanent</option>
                                            <option value="1">Current</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Country *</label>
                                        <select class="form-control" v-model="address.CountryID" v-on:change="loadCities(address.CountryID)" required>
                                            <option value="">--Select--</option>
                                            <option v-for="item in countries" :value="item.CountryID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>City *</label>
                                        <select class="form-control" v-model="address.CityID" required>
                                            <option value="">--Select--</option>
                                            <option v-for="item in cities" :value="item.CityID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Zip Code</label>
                                        <input class="form-control" v-model="address.ZipCode" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Address *</label>
                                        <input class="form-control" v-model="address.Address" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="isPostal" v-model="address.IsPostalAddress">
                                            <label for="isPostal" class="custom-control-label" style="font-weight: 500">Postal Address</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success">Save changes</button>
                        </div>
                    </form>

                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalDeleteAddress">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Delete</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h3>Are you sure you want to delete this record ?</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="deleteAddress()" class="btn btn-danger">Delete</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalEmergencyContact">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <h4 class="modal-title">Emergency Contact</h4>
                    </div>

                    <form id="emergencyContact" v-on:submit="saveEmergencyContact">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Relation *</label>
                                        <select class="form-control" v-model="emergencyContact.RelationID" required>
                                            <option value="">--Select--</option>
                                            <option v-for="item in relations" :value="item.RelationID">{{item.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Name *</label>
                                        <input class="form-control" v-model="emergencyContact.Name" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Type *</label>
                                        <select class="form-control" v-model="emergencyContact.Type" required>
                                            <option value="">--Select--</option>
                                            <option value="0">Personal</option>
                                            <option value="1">Home</option>
                                            <option value="2">Work</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Contact *</label>
                                        <input class="form-control" type="tel" v-mask="'###########'" pattern=".{11,11}" title="11 digits required" v-model="emergencyContact.ContactNo" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success">Save changes</button>
                        </div>
                    </form>

                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

        <div class="modal fade" id="modalDeleteEmergencyContact">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Delete</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h3>Are you sure you want to delete this record ?</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="deleteEmergencyContact()" class="btn btn-danger">Delete</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

    </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        props: {
            employeeId: Number,
            sendEmp: Function,
            sendImg: Function,
        },
        data() {
            return {
                contacts: [],
                contact: { EmployeeContactID: 0, Type: '', ContactNo: '', Email: '' },
                contactIndex: -1,

                addresses: [],
                address: { EmployeeAddressID: 0, Type: '', CountryID: '', CityID: '', Address: '', ZipCode: '', IsPostalAddress: false },
                addressIndex: -1,

                emergencyContacts: [],
                emergencyContact: { RelationID: '', Name: '', Type: '', ContactNo: '' },
                emergencyContactIndex: -1,

                countries: [],
                cities: [],
                relations: []
            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {

            pageLoad() {
                startReq();
                var vm = this;
                axios.get('/api/EmployeesApi/pageLoadContact?id=' + vm.employeeId)
                    .then(function (res) {
                        endReq();

                        vm.countries = res.data.countries;
                        vm.relations = res.data.relations;

                        if (res.data.contacts)
                            vm.contacts = res.data.contacts;

                        if (res.data.addresses)
                            vm.addresses = res.data.addresses;

                        if (res.data.emergencyContacts)
                            vm.emergencyContacts = res.data.emergencyContacts;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showContactModal(data, index) {
                if (data) {
                    this.contact = Object.assign({}, data);
                    this.contactIndex = index
                }
                else {
                    this.contact = { EmployeeContactID: 0, Type: '', ContactNo: '', Email: '' };
                    this.contactIndex = -1;
                }

                $('#modalContact').modal('show');
            },

            saveContact(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveContact?id=' + vm.employeeId, {
                    contact: vm.contact
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.contactIndex == -1)
                                vm.contacts.push(res.data.contact);
                            else {
                                vm.contacts[vm.contactIndex] = res.data.contact;
                                vm.contactIndex = -1;
                                $('#modalContact').modal('hide');
                            }

                            vm.contact = { EmployeeContactID: 0, Type: '', ContactNo: '', Email: '' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteContact() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteContact?id=' + vm.contacts[vm.contactIndex].EmployeeContactID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.contacts.splice(vm.contactIndex, 1);
                            vm.contactIndex = -1;
                            $('#modalDeleteContact').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showAddressModal(data, index) {
                if (data) {
                    this.address = Object.assign({}, data);
                    this.addressIndex = index
                    this.loadCities(this.address.CountryID);
                }
                else {
                    this.address = { EmployeeAddressID: 0, Type: '', CountryID: '', CityID: '', Address: '', ZipCode: '', IsPostalAddress: false };
                    this.addressIndex = -1;
                }

                $('#modalAddress').modal('show');
            },

            saveAddress(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveAddress?id=' + vm.employeeId, {
                    address: vm.address
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.addressIndex == -1)
                                vm.addresses.push(res.data.address);
                            else {
                                vm.addresses[vm.addressIndex] = res.data.address;
                                vm.addressIndex = -1;
                                $('#modalAddress').modal('hide');
                            }

                            vm.address = { EmployeeAddressID: 0, Type: '', CountryID: '', CityID: '', Address: '', ZipCode: '', IsPostalAddress: false };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteAddress() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteAddress?id=' + vm.addresses[vm.addressIndex].EmployeeAddressID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.addresses.splice(vm.addressIndex, 1);
                            vm.addressIndex = -1;
                            $('#modalDeleteAddress').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showEmergencyContactModal(data, index) {
                if (data) {
                    this.emergencyContact = Object.assign({}, data);
                    this.emergencyContactIndex = index
                }
                else {
                    this.emergencyContact = { RelationID: '', Name: '', Type: '', ContactNo: '' };
                    this.emergencyContactIndex = -1;
                }

                $('#modalEmergencyContact').modal('show');
            },

            saveEmergencyContact(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/api/EmployeesApi/saveEmergencyContact?id=' + vm.employeeId, {
                    emergencyContact: vm.emergencyContact
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.emergencyContactIndex == -1)
                                vm.emergencyContacts.push(res.data.emergencyContact);
                            else {
                                vm.emergencyContacts[vm.emergencyContactIndex] = res.data.emergencyContact;
                                vm.emergencyContactIndex = -1;
                                $('#modalEmergencyContact').modal('hide');
                            }

                            vm.emergencyContact = { RelationID: '', Name: '', Type: '', ContactNo: '' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteEmergencyContact() {
                var vm = this;
                startReq();
                axios.get('/api/EmployeesApi/deleteEmergencyContact?id=' + vm.emergencyContacts[vm.emergencyContactIndex].EmployeeEmergencyContactID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.emergencyContacts.splice(vm.emergencyContactIndex, 1);
                            vm.emergencyContactIndex = -1;
                            $('#modalDeleteEmergencyContact').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            loadCities(countryID) {
                startReq();
                var vm = this;
                axios.get('/api/EmployeesApi/loadCities?id=' + countryID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            vm.cities = res.data.cities;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            clear() {
                location.reload();
            }

        }
    })</script>

<style>
    .h4-t {
        margin-top: -9px;
        margin-bottom: -5px;
        font-weight: 600
    }

    .h4-c {
        margin-bottom: -5px;
        font-weight: 600
    }
</style>





// WEBPACK FOOTER //
// src/components/hr/employeeContact.vue